import { withFormik } from "formik";
import { compose } from "@reduxjs/toolkit";
import { withAction } from "HOCs/withAction";
import { setNotification } from "services";
import mapPropsToValues, { FormValues } from "./mapPropsToValue";
import validationSchema from "./validationSchema";
import Contact from "./Contact";

export const ContactContainer = compose(
  withAction((props: any) => setNotification(props), "setNotification"),
  withFormik<any, FormValues>({
    mapPropsToValues,
    validationSchema,
    handleSubmit: () => null,
    enableReinitialize: true,
    validateOnMount: true,
  })
)(Contact);

export default ContactContainer;
